<template>
  <div class="my">
    <!--<van-nav-bar title="我的" :left-arrow="false" border/>-->
    <div class="header van-hairline--bottom">
      <div class="left-con">
        <div class="img-con" @click="showMyAvatar(userInfo.avatar)">
          <img
            class="img"
            :src="userInfo.avatar? ( checkQiNiuUrl(userInfo.avatar)+'?imageView2/0/w/100/h/100') : (checkQiNiuUrl('FtKRQqCkGtCCFLF_VQStosKgqOJP'))"
            alt="头像获取失败"
          >
        </div>
      </div>
      <div class="name-con" @click="goInformation">
        <div class="name">{{ userInfo.nickname }}<span class="gender" :class="userInfo.sex?'gender-male':'gender-female'"></span></div>
        <div class="member">{{ memberName }} </div>
      </div>
      <div class="code-con" @click="goInformation">
        <img class="qr-code" :src="checkQiNiuUrl('FkKEOmq5kXQWHF-pINqy-0MnJac4')" alt="二维码"><van-icon class="header-right-icon" name="arrow" />
      </div>
    </div>

    <div class="number-con">
      <div class="flex">
        <p class="num">{{ friendList.length || 0 }}</p>
        <p class="text">好友</p>
      </div>
      <div class="number-line"></div>
      <div class="flex">
        <p class="num">0</p>
        <p class="text">已关注</p>
      </div>
      <div class="number-line"></div>
      <div class="flex">
        <p class="num">0</p>
        <p class="text">粉丝</p>
      </div>
    </div>

    <div class="middle-con">
      <!--其它-->
      <div class="tool-1">
        <div class="flex-item">
          <div class="click-item clickable" @click="goWallet">
            <img class="icon icon1" :src="checkQiNiuUrl('FgVBOgdGrLNEtCDTFNf_mgL2mrsi')" alt="">
            <p class="text">钱包</p>
          </div>
        </div>
        <!--<div class="flex-item">
          <div class="click-item clickable">
            <img class="icon icon2" :src="checkQiNiuUrl('FhQL7V33SlB2ftiZuqRThilf__Jp')" alt="">
            <p class="text">优惠券</p>
          </div>
        </div>-->
        <div class="flex-item">
          <div class="click-item clickable" @click="goFollow">
            <img class="icon icon3" :src="checkQiNiuUrl('FkC9FBfsCgf-8HOXAly8BSYUhTsc')" alt="">
            <p class="text">关注</p>
          </div>
        </div>
        <div class="flex-item">
          <div class="click-item clickable" @click="goShoppingCart">
            <img class="icon icon3" :src="checkQiNiuUrl('Fs1l190UUt4Q12B-rk8qF_HpKek6')" alt="">
            <p class="text">购物车</p>
          </div>
        </div>
        <div class="flex-item">
          <div class="click-item clickable" @click="goCollection">
            <img class="icon icon4" :src="checkQiNiuUrl('FmiKLG-neaNmpIPi1XzeTcxO1kJP')" alt="">
            <p class="text">收藏</p>
          </div>
        </div>
      </div>

      <!--会员俱乐部-->
      <div class="tool-2">
        <div class="tool-2-title">会员俱乐部</div>
        <div class="flex-con">
          <div class="flex-item">
            <div class="click-item clickable" @click="goMember">
              <img class="icon" :src="checkQiNiuUrl('FqjGYVHkrfLbo2W6MMby1r3JXkNQ')" alt="">
              <p class="text">会员奖励</p>
            </div>
          </div>
          <div class="flex-item">
            <div class="click-item clickable" @click="shoppingAwards">
              <img class="icon" :src="checkQiNiuUrl('FucGcwbijLq9Eote1GFTGfuJ4roE')" alt="">
              <p class="text">购物奖励</p>
            </div>
          </div>
          <div class="flex-item">
            <div class="click-item clickable" @click="yundian">
              <img class="icon" :src="checkQiNiuUrl('Fg2atxO3xERJiJ2fvOZSwc-3Fmnr')" alt="">
              <p class="text">云店管家</p>
            </div>
          </div>
          <div class="flex-item">
            <div class="click-item clickable" @click="goInvitation">
              <img class="icon" :src="checkQiNiuUrl('FnPSG4LbE6nkpjeqMirAdIqMsR92')" alt="">
              <p class="text">邀请推广</p>
            </div>
          </div>
        </div>
      </div>


      <!--商品订单-->
      <van-collapse class="order" v-model="orderActive">
        <van-collapse-item name="1" value-class="right-text">
          <div slot="title">商品订单</div>
          <div slot="value" @click.stop="allOrder">全部订单</div>
          <div class="order-con">
            <div class="flex-item" @click="goSgOrder(1)">
              <div class="click-item clickable">
                <img class="icon1" :src="checkQiNiuUrl('FmmxdZBEEibnCjBp92ZNSOMbJ-kU')" alt="">
                <p class="text">待付款</p>
              </div>
            </div>
            <div class="flex-item" @click="goSgOrder(2)">
              <div class="click-item clickable">
                <img class="icon2" :src="checkQiNiuUrl('FsrZLFP2cpMZNzKarBtoUOqWCgwO')" alt="">
                <p class="text">待收货</p>
              </div>
            </div>
            <div class="flex-item" @click="goSgOrder(3)">
              <div class="click-item clickable">
                <img class="icon3" :src="checkQiNiuUrl('Ful6ahiMcT24Yh9SWg4eSyvHXfPv')" alt="">
                <p class="text">已完成</p>
              </div>
            </div>
            <div class="flex-item" @click="goSgOrder(4)">
              <div class="click-item clickable">
                <img class="icon4" :src="checkQiNiuUrl('Fq4DR2qtaqRZHDdhxRL1KSzJUQjb')" alt="">
                <p class="text">已取消</p>
              </div>
            </div>
            <!--<div class="flex-item">
              <div class="click-item clickable">
                <img class="icon5" :src="checkQiNiuUrl('FjT5Gin6pWGcvotFn_jPsBpOzmCj')" alt="">
                <p class="text">退款售后</p>
              </div>
            </div>-->
          </div>
        </van-collapse-item>
      </van-collapse>

      <!--知识订单-->
      <div class="knowledge-order">
        <van-collapse class="" v-model="knowledgeOrderActive">
          <van-collapse-item name="1">
            <div slot="title">
              <!--<img class="knowledge-order-img" :src="checkQiNiuUrl('FiHndoP_u9IzHU9paKMVtskob8Oz')" alt="">-->
              知识订单
            </div>
            <div class="knowledge-order-con">
              <div class="flex-item">
                <div class="click-item clickable" @click="goKnowledgeOrderHistory">
                  <img class="icon1" :src="checkQiNiuUrl('FoigFoRZtGUAtB3Xxg8yXFZrMOYP')" alt="">
                  <p class="text">订单记录</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="click-item clickable" @click="goMyStudy">
                  <img class="icon2" :src="checkQiNiuUrl('Fkd5Aujn08CXx0mXSdBc9XkJSR8U')" alt="">
                  <p class="text">我的学习</p>
                </div>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>

    <!--其它-->
    <!--
    <div class="tool-3">
      <div class="flex-item clickable">
        <img class="icon" src="../assets/my/tool3-icon1.png" alt="">
        <p class="text">优惠券</p>
      </div>
      <div class="flex-item clickable">
        <img class="icon" src="../assets/my/tool3-icon2.png" alt="">
        <p class="text">商品收藏</p>
      </div>
      <div class="flex-item clickable">
        <img class="icon" src="../assets/my/tool3-icon3.png" alt="">
        <p class="text">云店关注</p>
      </div>
      <div class="flex-item clickable">
        <img class="icon" src="../assets/my/tool3-icon4.png" alt="">
        <p class="text">历史浏览</p>
      </div>
      <div class="flex-item clickable">
        <img class="icon" src="../assets/my/tool3-icon5.png" alt="">
        <p class="text">待分享</p>
      </div>
    </div>
-->

    <!--其它-->
    <div class="other">
      <!--<van-cell is-link>
        <template slot="title">
          <img class="icon icon1" :src="checkQiNiuUrl('Fpd99m0-WxiVnlLoLhrESA7HRUec')" alt="">
          <span class="other-title">消息通知</span>
        </template>
      </van-cell>-->
      <!--<van-cell is-link>
        <template slot="title">
          <img class="icon icon2" :src="checkQiNiuUrl('FhWaxnvFnuvKhxIO0s_PuzSPV3qc')" alt="">
          <span class="other-title">任务列表</span>
        </template>
      </van-cell>-->


      <van-cell is-link @click="goService">
        <template slot="title">
          <!--<img class="icon icon3" :src="checkQiNiuUrl('Fg1K86tbVeGEc250lMo8JS2H8ACq')" alt="">-->
          <span class="other-title">客服中心</span>
        </template>
      </van-cell>

      <!--<van-cell is-link @click="goSetting">
        <template slot="title">
          <img class="icon icon4" :src="checkQiNiuUrl('FpSJFs0A0_srJczaVHzzMdMubjww')" alt="">
          <span class="other-title">设置</span>
        </template>
      </van-cell>-->
    </div>
    <wx-config v-on:wxConfigReady="wxConfigReady" />
  </div>
</template>

<script>
import wxConfig from '@/components/weixin/wxConfig'
import { memberPlatformGradeV2 } from '@/api/member'
import { getUserInfo } from '@/api/my'
import { mapGetters } from 'vuex'
export default {
  components: {
    wxConfig,
  },
  data() {
    return {
      userOpenId: this.session('userOpenId') || '',
      orderActive: ['1'], // 为1时展开
      knowledgeOrderActive: ['0'], // 为1时展开

      userInfo: {},

      memberName: '云柑会员', // 会员名称
      memberId: '1', // 会员等级

      storeShow: false,

      origin: window.location.origin,
    }
  },
  computed: {
    ...mapGetters([
      'friendList'
    ]),
  },
  created() {
    if(this.userInfo.userNo){
      this.userInfo = this.session('userInfo')
      this.getMemberRank()
    }else if(this.userOpenId){
      this.getUserInfo({openId: this.userOpenId})
    }else {
      console.log('未登录')
    }

    // window.setTimeout(()=>{
    //   if(this.userOpenId){
    //     this.$store.dispatch('my/changeFriendList')
    //   }
    // },500)




  },
  methods: {
    goInformation() {
      this.$router.push({ name: 'information' })
    },
    goCollection() {
      this.$router.push({ name: 'collection' })
    },
    goFollow() {
      this.$router.push({ name: 'follow' })
    },
    goShoppingCart() {
      this.$router.push({ name: 'shoppingCart' })
    },
    goWallet() {
      // this.$toast('钱包功能升级中，敬请期待！')
      // return false
      this.$router.push({ name: 'wallet' })
    },
    goInvitation() {
      this.$router.push({ name: 'invitation' })
    },
    goMember() {
      this.$router.push({ name: 'platformMember' })
    },
    shoppingAwards() {
      this.$router.push({ name: 'shoppingAwards' })
    },
    allOrder(){
      this.$store.commit('my/change_sgOrderType', 0)
      this.$router.push({ name: 'sgOrder' })
    },
    goSgOrder(i){
      this.$store.commit('my/change_sgOrderType', i)
      this.$router.push({ name: 'sgOrder' })
    },
    goKnowledgeOrderHistory() {
      this.$router.push({ name: 'knowledgeOrderHistory' })
    },
    goMyStudy() {
      this.$router.push({ name: 'myStudy' })
    },
    goService() {
      this.$router.push({ name: 'service' })
    },
    goSetting() {
      this.$router.push({ name: 'setting' })
    },

    yundian() {
      this.appDownload({inviteUserId: this.session('userOpenId')});
    },

    showMyAvatar(url){
      if(url){
        this.showImagePreview({ images: [url], startPosition: 0 })
      }
    },




    //获取用户信息
    getUserInfo(data){
      getUserInfo(data).then(res => {
        if(res.code===200){
          this.session('userInfo',res.data)
          this.userInfo = res.data;
          this.getMemberRank()
          // this.$router.replace(this.session('beforeLoginUrl')||'/')
        }
      })
    },


    //获取会员等级
    getMemberRank(){
      memberPlatformGradeV2({}).then(res => {
        if(res.code===200){
          this.memberName = res.data.memberName
        }
      })
    },

    // 微信分享
    wxConfigReady(){
      window.setTimeout(()=>{
        //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
        window.wx.updateAppMessageShareData({
          title: this.session('user').nickname + '给你分享了云柑社区-我的', // 分享标题
          // desc: '京东社交电商战略合作伙伴', // 分享描述
          link: this.origin + '/my?inviteUserId=' + this.session('userOpenId'),
          imgUrl: this.origin + '/image/ant-icon.png', // 分享图标
          success: function () {
            // 设置成功
            console.log('my 设置分享朋友成功！')
          }
        });
        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
        window.wx.updateTimelineShareData({
          title: this.session('user').nickname + '给你分享了云柑社区-我的', // 分享标题
          link: this.origin + '/my?inviteUserId=' + this.session('userOpenId'),
          imgUrl: this.origin + '/image/ant-icon.png', // 分享图标
          success: function () {
            // 设置成功
            console.log('my 设置分享朋友圈成功！')
          }
        })
      },300)
    },
  }
}
</script>

<style lang="less" scoped>
@url: 'https://fileqn.anttalk.vip/';
.my{
  padding-bottom: 60px;
  .header{
    display: flex;
    height: 90px;
    .left-con{
      display: inline-flex;
      width: 77px;
      align-items: center;
      justify-content: center;
      .img-con{
        position: relative;
        width: 50px;
        height: 50px;
        .img{
          font-size: 12px;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .vip-icon{
          position: absolute;
          width: 13px;
          height: 19px;
          bottom: 0px;
          right: 3px;
        }
        .vip1{
          background: url("@{url}FqvdyKzdOvhFc6yeHGCISPDh3Mq6") no-repeat 50% 50%;
          background-size: 99%;
        }
        .vip2{
          background: url("@{url}FmQsU_Ysx0rOaBp38p192_OKtyAY") no-repeat 50% 50%;
          background-size: 99%;
        }
        .vip3{
          background: url("@{url}Fn5_XQKTUnolmg_YGwNoqvaFFy6J") no-repeat 50% 50%;
          background-size: 99%;
        }
      }
    }

    .name-con{
      /*padding-top: 16px;*/
      flex: 1;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;

      .name{
        font-size: 16px;
        .gender{
          display: inline-block;
          width: 17px;
          height: 17px;
          vertical-align: middle;
          margin-left: 4px;
        }
        .gender-male{
          background: url("@{url}FlTz94iQD1zg0erD3QmweXycSSbZ") no-repeat 50% 20%;
          background-size: 12px;
        }
        .gender-female{
          background: url("@{url}Fr90OHUo0zRvnWA9yev99UPyAEtT") no-repeat 50% 00%;
          background-size: 10px;
        }
      }
      .member{
        font-size: 12px;
        color: #409aed;
      }

    }
    .code-con{
      display: inline-flex;
      width: 68px;
      align-items: center;
      .qr-code{
        width: 34px;
        height: 34px;
        margin-right: 4px;
      }
      .header-right-icon{
        color: #969799;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
  .number-con{
    display: flex;
    height: 60px;
    font-size: 12px;

    .flex{
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      .num{
        font-size: 15px;
        color: #000;
        line-height: 24px;
      }
      .text{
        font-size: 12px;
        color: #999;
      }
    }
    .number-line{
      background-color: #edecec;
      width: 1px;
      margin: 15px 0;
    }
  }

  .middle-con{
    background-color: #f4f4f4;
    padding: 10px 12px;
    .tool-1{
      border-radius: 5px;
      background-color: #fff;
      height: 72px;
      margin-bottom: 10px;
      display: flex;
      .flex-item{
        flex: 1;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        .click-item{
          width: 60px;
          height: 60px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .icon1{width: 20px;height: 21px;}
          .icon2{width: 23px;height: 18px;}
          .icon3{width: 22px;height: 21px;}
          .icon4{width: 22px;height: 19px;}
          .text{
            display: block;
            width: 100%;
            font-size: 12px;
            text-align: center;
            padding-top: 10px;
            line-height: 1;
          }
        }

      }
    }

    .tool-2{
      background-color: #fff;
      margin-bottom: 10px;
      border-radius: 5px;
      .tool-2-title{
        font-size: 15px;
        line-height: 44px;
        padding: 0 15px;
        border-bottom: 1px solid #edecec;
      }
      .flex-con{
        display: flex;
        height: 90px;
        .flex-item{
          flex: 1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          .click-item{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 70px;
            height: 70px;
            .icon{
              display: block;
              width: 40px;
              height: 40px;
              margin-bottom: 10px;
            }
            .text{
              display: block;
              width: 100%;
              font-size: 12px;
              text-align: center;
              line-height: 1;
            }
          }

        }
      }
    }
    .order{border-bottom: 10px solid #f4f4f4;}
    .order, .knowledge-order{
      border-radius: 5px;
      overflow: hidden;
      .order-img, .knowledge-order-img{
        display: inline-block;
        vertical-align: text-bottom;
        width: 18px;
        height: 18px;
        margin-right: 11px;
      }
      .order-con, .knowledge-order-con{
        display: flex;
        overflow: hidden;
        .flex-item{
          flex: 1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .click-item{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 60px;
            height: 60px;
            .icon1{width: 21px;height: 17px;}
            .icon2{width: 21px;height: 17px;}
            .icon3{width: 21px;height: 21px;}
            .icon4{width: 21px;height: 19px;}
            .text{
              display: block;
              width: 100%;
              font-size: 12px;
              text-align: center;
              padding-top: 8px;
              line-height: 1;
            }
          }
        }
      }
      .knowledge-order-con{
        height: 70px;
        .flex-item{
          .click-item{
            .icon1{width: 17px;height: 20px;}
            .icon2{width: 25px;height: 20px;}
          }
        }
      }
    }
  }

  .tool-3{
    border-bottom: 10px solid rgb(238,238,238);
    display: flex;
    /*height: 72px;*/
    .flex-item{
      padding: 10px 0;
      flex: 1;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .icon{
        width: 22px;
        height: 22px;
      }
      .text{
        display: block;
        width: 100%;
        font-size: 12px;
        text-align: center;
        padding-top: 10px;
        line-height: 1;
      }
    }
  }

  .other{
    .icon{
      display: inline-block;
      vertical-align: text-bottom;
      margin-right: 10px;
    }
    .icon1{width: 17px;height: 21px;}
    .icon2{width: 16px;height: 16px;}
    .icon3{width: 18px;height: 16px;}
    .icon4{width: 18px;height: 19px;}
    .other-title{
      font-size: 15px;
      color: #000;
    }
  }
}
</style>
<style lang="less">
.my{
  .order{
    .right-text{
      flex: 0.3;
    }
  }
  .order, .knowledge-order{
    .van-collapse-item__content{
      /*padding: 5px 15px;*/
      padding: 0;
      color: #000;
    }
  }
}
</style>
